<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import routerPromise from '@/router'
import Cookies from "@/utils/cookie";
export default {
    name: 'App',
    created() {
        let hash = new URL(window.location.href).hash;
        if (!Cookies.getCookie('token') && hash != '#/') {
            this.$message.error('请先登录');
            routerPromise.then(router => { router.router.push({ path: '/' }) })
        }
        if (Cookies.getCookie('token')) {
            if (this.$routerList.length === 0) { this.$message.error('未获取菜单权限') }
        }
    },
}
</script>

<style lang="less" scoped>
#app {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue